import { Outlet, Route } from 'react-router-dom';
import MySubmissions from '../pages/MySubmissions';
import ProtectedHOC from '../components/ProtectedHOC';
import Review from '../pages/Review';
import ReviewList from '../pages/ReviewList';
import Account from '../pages/User/Account';
import Inbox from 'src/pages/Inbox';
import MySubmission from 'src/pages/MySubmissions/[id]';
import { ErrorBoundary } from 'react-error-boundary';
import { RevisionFormProvider } from 'src/contexts/RevisionFormContext';
import SubmissionDataProvider from 'src/contexts/SubmissionDataProvider';
import ReviewDataProvider from 'src/contexts/ReviewDataProvider';
import MyAssessments from 'src/pages/MyTask/Assessments';
import AssessmentDataProvider from 'src/contexts/AssessmentDataProvider';
import Assessment from 'src/pages/MyTask/Assessments/[id]';
import { ModalError } from 'src/components/ErrorBoundaries/ModalError';
import MyAdjudications from 'src/pages/MyTask/Adjudications';
import Adjudication from 'src/pages/MyTask/Adjudications/[id]';
import AdjudicationDataProvider from 'src/contexts/AdjudicationDataProvider';
import { CoReviewFlow } from '../pages/Review/CoReviewFlow';
import JournalIndex from '../pages/JournalIndex';

const UserRoutes = (
  <>
    <Route path="journal-index" element={<JournalIndex />} />

    <Route path="reviews" element={<Outlet />}>
      <Route index element={<ReviewList />} />
      <Route
        path=":id"
        element={
          <ProtectedHOC relation="viewer" entityType="review" entityKey="id">
            <ReviewDataProvider>
              <Outlet />
            </ReviewDataProvider>
          </ProtectedHOC>
        }
      >
        <Route index element={<Review />} />
        <Route path="coreview-invite" element={<CoReviewFlow />} />
      </Route>
    </Route>

    <Route path="my-submissions" element={<Outlet />}>
      <Route index element={<MySubmissions />} />
      <Route
        path=":submissionId"
        element={
          <ProtectedHOC
            relation="viewer"
            entityType="submission"
            entityKey="submissionId"
          >
            <RevisionFormProvider>
              <SubmissionDataProvider>
                <ErrorBoundary
                  fallbackRender={({ error }) => {
                    return (
                      <ModalError
                        fallbackUrl={'/app/my-submissions'}
                        error={error}
                      />
                    );
                  }}
                >
                  <MySubmission />
                </ErrorBoundary>
              </SubmissionDataProvider>
            </RevisionFormProvider>
          </ProtectedHOC>
        }
      />
    </Route>
    <Route path="assessments" element={<Outlet />}>
      <Route index element={<MyAssessments />} />
      <Route
        path=":assessmentId"
        element={
          <ProtectedHOC
            relation="canReview"
            entityType="early_assessment"
            entityKey="assessmentId"
          >
            <AssessmentDataProvider>
              <Assessment />
            </AssessmentDataProvider>
          </ProtectedHOC>
        }
      />
    </Route>

    <Route path="adjudications" element={<Outlet />}>
      <Route index element={<MyAdjudications />} />
      <Route
        path=":adjudicationId"
        element={
          <ProtectedHOC
            relation="canReview"
            entityType="adjudication"
            entityKey="adjudicationId"
          >
            <AdjudicationDataProvider>
              <Adjudication />
            </AdjudicationDataProvider>
          </ProtectedHOC>
        }
      />
    </Route>

    <Route path="account" element={<Account />} />
    <Route path="inbox" element={<Inbox />} />
  </>
);

export default UserRoutes;
